// extracted by mini-css-extract-plugin
module.exports = {"text-area":"text-area--2W-fM","textArea":"text-area--2W-fM","area":"area--3NNLm","area-wrap":"area-wrap--2TCoV","areaWrap":"area-wrap--2TCoV","editable":"editable--9xXJU"};